"use strict";


angular.module("customer")
.controller("InvoiceAttachmentController", function(
    $scope, $stateParams, $http, InvoiceAttachmentService, UserService, INVOICE_ATTACHMENTS_MAX
) {
    $scope.INVOICE_ATTACHMENTS_MAX = INVOICE_ATTACHMENTS_MAX;
    $scope.invoice = InvoiceAttachmentService.get($stateParams.id)
    UserService.isUserFetched().then(function onSuccess(user) {
        if (user) {
            $scope.dedicatedVendorId = user.dedicated_vendor_id;
        }
    });

    this.onAddImageAttachment = function() {
        $scope.invoice.$get($stateParams.id);
    }
});



//////////////////
// WEBPACK FOOTER
// ./customer/sections/invoice-attachment/invoice-attachment.controller.js
// module id = 914
// module chunks = 0